<script>
export default {
  name: 'TeamMember',
  props: {
    name: String,
    nickname: String,
    occupation: String,
    photo: String,
    active: Boolean,
  },
};
</script>

<template>
  <div :class="{'team-member': true, 'team-member_active': active}">
    <img :src="photo" class="photo">
    <div class="about">
      <div class="name">
        {{name}}
      </div>
      <div class="occupation">
        {{occupation}}
      </div>
      <div class="nickname">
        @{{nickname}}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.team-member {
  color: var(--main-bright);
  font-weight: bold;
  background: var(--main-dark);
  display: flex;
  cursor: pointer;

  transition: color 0.2s, background-color 0.2s;
  &:hover {
    color: var(--main-dark);
    background: var(--main-bright);
  }
}

.team-member_active {
  color: var(--main-dark);
  background: var(--main-bright);

  $hover-shift: 5px;
  $hover-shift-negative: -$hover-shift;

  box-shadow: $hover-shift-negative $hover-shift-negative 0 $hover-shift #fb0047,
  $hover-shift $hover-shift 0 $hover-shift #0ffbf9;
}

$photo-size: 138px;
.photo {
  width: $photo-size;
  height: $photo-size;
}

.about {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 20px;
}

.name {
  font-size: var(--font-size-m);
}

.occupation {
  margin-top: 8px;
  font-size: var(--font-size-xs);
  max-width: 320px;
}

.nickname {
  margin-top: 14px;
  font-size: var(--font-size-s);
}
</style>
